import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const ArrowBack = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg viewBox='0 0 16 16' fill='currentColor' xmlns='http://www.w3.org/2000/svg' ref={ref} {...props}>
        <path d='M12 2.53398L10.8 1.33398L4 8.00065L10.8 14.6673L12 13.4673L6.4 8.00065L12 2.53398Z' fill='currentColor' />
    </svg>
));
